import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const AdminResearchContainer = styled.div`
  padding: 2rem;
  max-width: 1000px;
  margin: 0 auto;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-family: 'Chau Philomene One';
  font-size: 2rem;
  color: #136F07;
`;

const BackButton = styled.button`
  background: #136F07;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 25px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background: #0f5a05;
  }
`;

const ResearchList = styled.div`
  display: grid;
  gap: 1.5rem;
`;

const ResearchCard = styled.div`
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-left: 4px solid #136F07;
`;

const CardTitle = styled.h3`
  font-family: 'Chau Philomene One';
  font-size: 1.3rem;
  color: #136F07;
  margin: 0 0 0.5rem 0;
`;

const CardMeta = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin: 0 0 0.5rem 0;
`;

const CardDescription = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 0 1rem 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const EditButton = styled.button`
  background: #4CAF50;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  cursor: pointer;
`;

const DeleteButton = styled.button`
  background: #f44336;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  cursor: pointer;
`;

const AdminResearch = () => {
  const navigate = useNavigate();
  const [researches, setResearches] = useState([]);

  useEffect(() => {
    const user = localStorage.getItem('currentUser');
    if (!user) {
      navigate('/login');
    }
  }, [navigate]);

  // Fetch research list
  useEffect(() => {
    const fetchResearch = async () => {
      try {
        const response = await fetch('http://localhost:5001/api/research');
        const data = await response.json();
        setResearches(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Failed to load research:', err);
        setResearches([]);
      }
    };
    fetchResearch();
  }, []);

  //  Handle delete
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this research?')) {
      try {
        await fetch(`http://localhost:5001/api/research/${id}`, {
          method: 'DELETE'
        });
        // Refresh list
        const response = await fetch('http://localhost:5001/api/research');
        const data = await response.json();
        setResearches(Array.isArray(data) ? data : []);
      } catch (err) {
        alert('Failed to delete research');
      }
    }
  };

  return (
    <AdminResearchContainer>
      <Header>
        <Title>Research Management</Title>
        <BackButton onClick={() => navigate('/admin')}>
          ← Back to Dashboard
        </BackButton>
      </Header>

      <ResearchList>
        {researches.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
            No research entries yet.
          </div>
        ) : (
          researches.map((research) => (
            <ResearchCard key={research.id}>
              <CardTitle>{research.title}</CardTitle>
              <CardMeta>
                📅 {research.date ? new Date(research.date).toLocaleDateString('en-PH') : 'No date'} • {research.type}
              </CardMeta>
              <CardDescription>
                {research.description?.substring(0, 150)}...
              </CardDescription>
              <ButtonGroup>
                <EditButton>Edit</EditButton>
                <DeleteButton onClick={() => handleDelete(research.id)}>
                  Delete
                </DeleteButton>
              </ButtonGroup>
            </ResearchCard>
          ))
        )}
      </ResearchList>
    </AdminResearchContainer>
  );
};

export default AdminResearch;